import { jsx as o } from "react/jsx-runtime";
import { DropdownMenuItemMobile as d } from "../dropdown-menu-item/index.js";
import { UserImage as f } from "../account-link/user-image.js";
import t from "./styles.module.less.js";
import h from "../folder.svg.js";
import C from "../settings.svg.js";
import I from "../logout.svg.js";
import { getAccountUrls as N } from "../../../../utils/webapp-chat-url.js";
const y = (a) => {
  const {
    getTranslation: e,
    language: n,
    handleLogout: s,
    hasNotifications: r,
    userImage: m,
    onClickUserImage: i,
    children: l,
    newChatUrl: g
  } = a, { myCasesUrl: c, settingsUrl: u } = N({
    origin: g,
    language: n
  });
  return /* @__PURE__ */ o(
    d,
    {
      language: n,
      titleLabel: e("pages.account"),
      link: c,
      classNames: {
        container: t.subMenuContainer,
        itemRow: t.itemRowClassName
      },
      items: [
        // {
        //   title: getTranslation('account.new-case'),
        //   icon: (
        //     <div className={styles.newCaseWrapper}>
        //       <PlusIcon className={styles.newCaseIcon} />
        //       <img src={PlusIconHover} className={styles.newCaseIconHover} />
        //     </div>
        //   ),
        //   path: '/chat?newCase=true',
        //   isGradient: true,
        // },
        {
          title: e("account.my-cases"),
          icon: /* @__PURE__ */ o(h, { className: t.accountIcon }),
          path: c
        },
        {
          title: e("account.settings"),
          icon: /* @__PURE__ */ o(C, { className: t.accountIcon }),
          path: u
        },
        {
          title: e("account.sign-out"),
          icon: /* @__PURE__ */ o(I, { className: t.accountIcon }),
          onClick: s
        }
      ],
      iconComponent: (p) => /* @__PURE__ */ o(
        "div",
        {
          onClick: () => i ? i(p) : void 0,
          className: t.userImageWrapper,
          children: /* @__PURE__ */ o(
            f,
            {
              userImage: m,
              hasNotifications: r
            }
          )
        }
      ),
      children: l ?? void 0
    }
  );
};
export {
  y as MobileAccountModalLink
};
